import PropTypes from 'prop-types';

import withTranslation from 'lib/shared/i18n/withTranslation';
import BaseField from 'components/Fields/BaseField/BaseField';
import { isValidSpotifyUri } from 'components/ContentReporting/validation-utils';

class SingleUriField extends BaseField {
  static propTypes = {
    t: PropTypes.func.isRequired,
    labelOverride: PropTypes.string,
    acceptedUriTypes: PropTypes.arrayOf(PropTypes.string),
    tPrefix: PropTypes.string,
  };

  isValid(value) {
    return isValidSpotifyUri(value, this.props.acceptedUriTypes) && super.isValid(value);
  }

  getLabel() {
    const { t, field, labelOverride, tPrefix } = this.props;

    if (labelOverride) {
      return t(tPrefix + labelOverride);
    }
    return t(`${tPrefix}${field.name}_label`);
  }
}

export default withTranslation()(SingleUriField);
